interface ICheckmark {
  color?: string;
  width?: number;
  height?: number;
  className?: string;
}

export const Checkmark = ({ color = 'black', width, height, className }: ICheckmark) => (
  <svg
    className={className}
    width={width || 10}
    height={height || 8}
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-qa="checkmark"
  >
    <path d="M1 3.27273L3.82353 6L9 1" stroke={color} />
  </svg>
);
